import '@/libs/ggo/wgo'
import '@/libs/ggo/kifu'
import '@/libs/ggo/sgfparser'
import '@/libs/ggo/player'
import '@/libs/ggo/basicplayer'
import '@/libs/ggo/player.editable'
import '@/libs/ggo/score'
import '@/libs/ggo/player.maker'
import '@/libs/ggo/player.trymove'
import '@/libs/dataTool.min'
import * as echarts from 'echarts';
import { ApiScore, GetData, ShareWeChat, getPdf } from '@/request/api'
import wx from 'weixin-js-sdk'
import config from '../config/config'
import router from '@/router';

export default {
    data() {
        return {
            pageData: null,  //接收html格式代码
            htmlTitle: "鹰眼报告",
            isTest: false,
            reportType: 0,                              // 1鹰眼 0小天 2恶手
            moveTimes: false, // 是否有每一手的用时时间
            platform: "",                               // mobile or desktop
            hawkResultUrl: "",                           // json 文件地址
            screenWidth: document.body.clientWidth,     // 屏幕宽
            screeHeight: document.body.clientHeight,    // 屏幕高
            boardWidth: 0,                              // 棋盘宽度
            echartsHeight: 0,                           // 图表高度
            tabActive: 1,                               // 当前选中图表类型
            boardType: 0,                               // 盘面类型 全盘0 布局1 中盘2 官子3
            playerType: 0,                              // 双方0 黑方1 白方2
            minHand: 0,                                 // 区间范围
            maxHand: 0,                                 // 区间范围
            eyeModeText: "首选点模式",
            eyeModeFlag: 1,
            badList: [],
            badActive: 0,
            bad_group: null,
            badGroupActive: "",
            showBadGroup: false,

            goodList: [],
            goodActive: 0,
            good_group: null,
            goodGroupActive: "",
            showGoodGroup: false,

            statisticsText: "区间模式",
            statisticsMode: false,                      // 统计学模式
            markerType: 'lastRed',                      // 手数类型
            result: {},                               // 棋谱信息
            moves: null,                                // 棋子列表
            bPlayer: "",                                 // 黑名称
            wPlayer: "",                                 // 白名称
            gResult: "",                                 // 对局结果
            isKm: false,                                 // 是不是让子棋
            gName: "",
            curPath: 0,                                  // 当前手数
            allPath: 0,                                   // 总手数
            bRemoveCount: 0,                              // 黑提子数
            wRemoveCount: 0,                              // 白提子数
            tryMoveFlag: false,                           // 是否开启试下
            isBranch: false,                              // 是否是分支
            moreFlag: false,                               // 显示更多
            loading: true,                                  // 手机端页面遮罩
            recommendStone: [],                            // 推荐落子点
            recommendStoneSelected: "",
            recommendStoneFlag: false,
            hoverStone: "",
            btntype: "",
            showStone: false,
            scoreFlag: false,                            // 是否开启形势判断
            app_key: "",
            scoreResult: {
                km: "",
                result: "",
                rate: "",
            },
            bw: 0,
            ww: 0,
            size: 0,
            hisPos: [],
            token: "",
            board_mouse: "",                     //悬浮显示试下分支
            stages1: 0,                           //阶段
            stages2: 0,                           //阶段
            oldMarker: {
                markerStyle: 'CR',
                markerNum: 1,
                start: 0,
            },
            markerConfig: {
                markerStyle: 'CR',
                markerNum: 1,
                lastMoveColor: 'red',
                start: 0,
            },
            move: {
                b_rate: 0,
                w_rate: 0,
                score_stdev: 0,
            },
            style: {
                color: "",
                trendTop: 0,
                fontsize: 0,
                legendTop: "",
            },
            colorList: [
                "",
                "rgba(36, 142, 53,1)",
                "rgba(36, 142, 53,1)",
                "rgba(36, 142, 53,1)",
                "#82AA28",
                "#DCB41E",
                "#EB8C00",
                "#DC5A14",
                "rgb(220,0,0)",
                "rgb(145,0,0)",
            ],
            stdevColor: [
                "#2464aa",
                "#24aaaa",
                "#248e35",
                "#82aa28",
                "#dcb41e",
                "#eb8c00",
                "#DC0000",
            ],
            teacher: "",
            institution: "",
            text: "正在生成鹰眼报告",
            createPDFFlag: false,
            windowsWidth: 0,
            tongjiText: "散点图",
            tongjiFlag: 1,
            isCache: true,
            dbWidth: 0,
        };
    },
    created() {
        // 设置平台
        this.platform = this.$route.name
        // 获取token
        this.token = this.getQueryVariable('token')
        this.teacher = this.getQueryVariable('teacher')
        this.institution = this.getQueryVariable('institution')
        this.isCache = this.getQueryVariable('cache')

        let temp_shadow={
            show: true,
            backgroundColor: "rgba(48, 19, 7, 0.5)"
        }, temp_scoregrid={
            left: '12%',
            right: '5%',
            top: '20%',
            bottom: '17%',
        },temp_stablegrid={
            left: '12%',
            right: '5%',
            top: '20%',
            bottom: '17%'
        }

        if (this.platform == "mobile") {
            this.style.color = "#4c4c4c"
            this.style.trendTop = '20%';
            this.style.fontsize = 12;
            this.style.legendTop = "5";
            this.style.trendgrid = {
                left: '15%',
                right: '15%',
                top: '30%',
                bottom: '20%',
            }
            this.style.badhandgrid = {
                left: '5%',
                right: '5%',
                top: '20%',
                bottom: '15%',
            }
            this.style.boxgrid = {
                left: '15%',
                right: '10%',
                top: '25%',
                bottom: '25%',
            }
            this.style.stablegrid = temp_stablegrid
            this.style.scoregrid=temp_scoregrid
            this.style.bandYshow = false;
        }else if(this.platform=="ifk_mobile"){
            this.style.color = "#fff"
            this.style.trendTop = '10%';
            this.style.fontsize = 10;
            this.style.legendTop = "5";
            this.style.trendgrid = {
                left: '10%',
                right: '10%',
                top: '25%',
                bottom: '17%',
                show: true,
                backgroundColor: "rgba(48, 19, 7, 0.5)"
            }
            this.style.badhandgrid = {
                left: '5%',
                right: '5%',
                top: '20%',
                bottom: '20%',
            }
            this.style.boxgrid = {
                left: '15%',
                right: '10%',
                top: '25%',
                bottom: '25%',
                show: true,
                backgroundColor: "rgba(48, 19, 7, 0.5)"
            }
            this.style.stablegrid = Object.assign(temp_shadow, temp_stablegrid);
            this.style.scoregrid = Object.assign(temp_shadow, temp_scoregrid);
            this.style.bandYshow = false;
        } else {
            this.style.color = "#fff"
            this.style.trendTop = '15%';
            this.style.fontsize = 14;
            this.style.legendTop = "10";
            this.style.trendgrid = {
                left: '8%',
                right: '8%',
                top: "20%",
                bottom: '12%',
            }
            this.style.badhandgrid = {
                left: '12%',
                right: '5%',
                top: '15%',
                bottom: '12%',
            }
            this.style.boxgrid = {
                left: '10%',
                right: '5%',
                top: '15%',
                bottom: '15%',
            }
            this.style.stablegrid = temp_stablegrid
            this.style.scoregrid=temp_scoregrid
            this.style.bandYshow = true;
        }
        var _this = this;
        window.onresize = function () {
            if (_this.windowsWidth != document.body.scrollWidth) {
                document.location.reload();
            }
        };
    },
    mounted() {
        this.windowsWidth = document.body.scrollWidth
        this.screenWidth = document.body.clientWidth;
        this.screeHeight = document.body.clientHeight;
        // 动态计算图表高度
        if (this.platform == "desktop") {
            if (this.screenWidth / 2 > this.screeHeight) {
                this.boardWidth = this.screeHeight - 75
            } else {
                this.boardWidth = this.screenWidth / 2 - 30
            }
            this.echartsHeight = this.boardWidth - 415
        }else if(this.platform=="ifk_mobile"){
            // window.screen.width <= 640
            let tempWidth =0,tempHeight=0;

            if( this.screenWidth > this.screeHeight){
                tempWidth=this.screenWidth
                tempHeight=this.screeHeight
            }else{
                tempWidth=this.screeHeight 
                tempHeight=this.screenWidth
            }
            if (tempWidth / 2 > tempHeight) {
                this.boardWidth =tempHeight-10//window.screen.width-30
                this.dbWidth =this.boardWidth
            } else {
                this.boardWidth =tempWidth / 2
                this.dbWidth =tempWidth - this.boardWidth-40
            }
            this.echartsHeight = this.boardWidth - 215
        }

        this.$nextTick(() => {
            //获取屏幕宽度
            this.initData()
        })
        this.fadeOutFlag = true;
        setTimeout(function () {
            this.loading = false
        }.bind(this), 3000);

    },
    methods: {
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return "";
        },
        intiChart() {
            this.inidDom()
            this.initBoard()
            this.loadTrend()
            this.loadBadHand()
            this.loadHitHand()
            this.loadStableLine();
            this.loadScoreChart();
            if (this.reportType == 2) {
                this.tabActive = 7
                this.switchBad()
                // this.badGroupTop({ key: "全部" })
            }
        },
        initData() {
            // let url = this.hawkResultUrl + 'v4/' + this.token + '.json';
            // let url = "https://yikedev.oss-cn-hangzhou.aliyuncs.com/1.json"
            // this.token = "1301d6e7b9943d12"
            GetData(this.token, this.isCache).then(result => {
                var res = result.data
                // 手数列表小于总手数
                if (res.hands.length < res.hands_count) {
                    if (this.platform == "mobile") {
                        window.location.href = window.location.protocol + "//" + window.location.host + "/report/oldMobile" + window.location.search;
                    } else {
                        window.location.href = window.location.protocol + "//" + window.location.host + "/report/report" + window.location.search;
                    }
                    return
                }
                // 如果当前页面不是小天鹰眼则跳转
                // if((res.app_key =="ifkadmin") && router.currentRoute._value.name!="ifk_mobile"){
                //     router.push({name:"ifk_mobile"})
                //     return
                // }

                this.result = res
                this.moves = res.hands
                this.allPath = res.hands_count
                this.maxHand = res.hands_count
                this.aiSize = 1750 / res.hands_count - 1
                this.reportType = res.report_flag
                this.app_key = this.result.app_key
                // 是否有用时数据
                if (this.moves && this.moves[1].move_time > 0){
                    this.moveTimes = true
                }
                this.intiChart()
            }).catch(res => {
                if (this.platform == "mobile") {
                     window.location.href = window.location.protocol + "//" + window.location.host + "/report/oldMobile" + window.location.search;
                } else {
                     window.location.href = window.location.protocol + "//" + window.location.host + "/report/report" + window.location.search;
                }
            })
        },
        //初始化图表
        inidDom() {
            // 棋局走势
            this.chartTrend = echarts.init(document.getElementById('chartTrend'));
            // 棋局用时
            this.chartMoveTimes = echarts.init(document.getElementById('chartMoveTimes'));
            // 恶手
            this.badHand = echarts.init(document.getElementById('badHand'));
            // 吻合度
            this.hitHand = echarts.init(document.getElementById('hitHand'));
            // 稳定性点散图
            this.statisticsBox = echarts.init(document.getElementById('statisticsBox'));
            // 稳定性折线图
            this.stableLine = echarts.init(document.getElementById('stableLine'));
            // 评分
            this.scoreChart = echarts.init(document.getElementById('scoreChart'));
            //
            this.complexChart = echarts.init(document.getElementById('complexChart'));
            // 决策质量
            this.decisionQuality = echarts.init(document.getElementById('decisionQuality'));
        },
        // 初始化棋盘
        initBoard() {
            let self = this
            let element = document.getElementById('board')
            self.player = new WGo.BasicPlayer(element, {
                sgf: this.result.sgf,
                enableWheel: false,
                displayVariations: false,
                enableKeys: false,
                markLastMove: false,
                allowIllegalMoves: false,
                update: function (e) {
                    if (e.op == 'init' && !this.tryMoveFlag) {
                        if (self.wPlayer == "") {
                            if (e.target.kifu.info.white && e.target.kifu.info.white.name) {
                                self.wPlayer = e.target.kifu.info.white.name
                            } else {
                                self.wPlayer = '执白';
                            }
                        }
                        if (self.bPlayer == "") {
                            if (e.target.kifu.info.black && e.target.kifu.info.black.name) {
                                self.bPlayer = e.target.kifu.info.black.name
                            } else {
                                self.bPlayer = '执黑';
                            }
                        }

                        if (self.gResult == "") self.gResult = e.target.kifu.info.RE || '结果';
                        if (self.gName == "") self.gName = e.target.kifu.info.GN || '弈客鹰眼';
                    }
                    self.size = e.target.kifuReader.kifu.size
                    self.stages1 = parseInt(parseInt(self.size * self.size / 6) / 2) * 2
                    self.stages2 = parseInt(parseInt(self.size * self.size / 2) / 2) * 2

                    if (self.chartTrend && !self.tryMoveFlag && e.path.m != 0 && self.platform != "mobile") {
                        self.chartTrend.dispatchAction({
                            type: 'showTip',
                            seriesIndex: 0,
                            dataIndex: e.path.m,
                        });
                    }
                    let node = e.node;
                    e.target.board.removeObject(self.hisPos);
                    self.hisPos = [];
                    if (e.path.m > self.allPath) {
                        return
                    }
                    // 主分支
                    if (self.tryMoveFlag) return
                    self.move = self.moves[e.path.m]
                    self.bRemoveCount = e.target.kifuReader.game.getCaptureCount(WGo.B)
                    self.wRemoveCount = e.target.kifuReader.game.getCaptureCount(WGo.W)
                    self.curPath = e.target.kifuReader.path.m
                    self.allPath = e.target.kifuReader.kifu.nodeCount
                    self.recommendStone = [];
                    let path = e.path.m

                    if (path <= self.allPath) {
                        //tempNextNode用来判断推荐点是不是下一手的实战点
                        var tempNextNode = null
                        if (path < self.allPath) tempNextNode = self.moves[path + 1].stone

                        var HisStone = false

                        let childrens = self.moves[path].children
                        for (let i = 0; i < childrens.length; i++) {
                            // 小天
                            if (self.reportType == 0 && i != 0) {
                                continue
                            }
                            if (self.hisPos.length >= 5) {
                                break
                            }
                            let child = childrens[i];
                            //实战点颜色 根据推荐点颜色 实战点颜色 根据推荐点颜色 实战点颜色 根据推荐点颜色
                            let num = (0.6 + child.po / childrens[0].po * 0.4).toFixed(1)
                            let color = 'rgba(36, 142, 53, ' + num + ')'

                            let outside = false;
                            if (path < self.allPath && self.moves[path + 1].stone == child.stone) {
                                color = self.colorList[child.level]
                                outside = true
                                HisStone = true
                                child.move_time = self.moves[path + 1].move_time // 实战用时
                                child.b_rate = self.moves[path + 1].b_rate
                                child.w_rate = self.moves[path + 1].w_rate
                            }
                            self.recommendStone.push(child)
                            let move = self.stoneToPos(child.stone)
                            let circleColor = 0
                            if (path + 1 <= self.allPath) {
                                circleColor = self.moves[path + 1].color
                            }
                            var rate = 0
                            if (child.color == 1) {
                                rate = child.b_rate.toFixed(1)
                            } else if (child.color == -1) {
                                rate = child.w_rate.toFixed(1)
                            } else {
                                if (self.moves[path].color == 1) {
                                    rate = child.w_rate.toFixed(1)
                                } else {
                                    rate = child.b_rate.toFixed(1)
                                }
                            }
                            self.hisPos.push({
                                type: "YKLB",
                                x: move.X,
                                y: move.Y,
                                c: color,
                                color: circleColor,
                                text: rate,
                                outside: outside
                            })
                        }
                        if (!HisStone && path < self.allPath) {
                            var temp = self.moves[path + 1]
                            var move = self.stoneToPos(tempNextNode)
                            var xx = self.stoneToPos(temp.stone)
                            //如果自选点没有分支 取下一手首选点的分支
                            temp.nodes = self.posToStone1(xx.X, xx.Y)
                            if (temp.children.length > 0) {
                                temp.nodes = temp.nodes + "," + temp.children[0].nodes
                            }
                            if (self.curPath < self.allPath) {
                                if (self.recommendStone.length == 5) {
                                    self.recommendStone.splice(4, 1);
                                }
                                self.recommendStone.push(temp)

                                if (self.hisPos.length == 5) {
                                    self.hisPos.splice(4, 1);
                                }

                                var rate = 0
                                if (temp.color == 1) {
                                    rate = temp.b_rate.toFixed(1)
                                } else if (temp.color == -1) {
                                    rate = temp.w_rate.toFixed(1)
                                } else {
                                    if (self.moves[path].color == 1) {
                                        rate = temp.w_rate.toFixed(1)
                                    } else {
                                        rate = temp.b_rate.toFixed(1)
                                    }
                                }

                                self.hisPos.push({
                                    type: "YKLB",
                                    x: move.X,
                                    y: move.Y,
                                    c: self.colorList[temp.level],
                                    color: temp.color,
                                    text: rate,
                                    outside: true
                                })
                            }
                        }
                        if (!self.showStone) {
                            e.target.board.addObject(self.hisPos)
                        }
                    }
                }
            })
            self.player.setCoordinates(true)
            self.editable = new WGo.Player.Editable(
                self.player,
                self.player.board,
                self.playCb.bind(self)
            )
            self.marker = new WGo.Player.Marker(
                self.player,
                self.player.board,
                self.markerConfig
            )
            self.player.last()
            self.editable.set(true)
            //是不是让子棋
            if (self.player.kifu.info.KM == 0) {
                self.isKm = true
            }
        },
        playCb(x, y, type) {
            if ((type == "cancelTry" || type == "board_mouse") && this.tryMoveFlag && this.board_mouse == "board_mouse") {
                this.closeTryMove()
                this.board_mouse = ""
                this.recommendStoneSelected = ""
                this.recommendStoneFlag = false
                return
            }
            if (type == "board_mouse" && !this.tryMoveFlag) {
                this.board_mouse = "board_mouse"
            }
            if (type == "cancelTry" && !this.tryMoveFlag) {
                this.board_mouse = ""
            }
            if (this.tryMoveFlag) {
                return
            }
            let stone = this.posToStone(x, y)
            let moves = this.moves[this.curPath].children
            let nodes = ""
            let isBranch = false
            let childrenFlag = false

            //start 如果实战点不在推荐点里面 把实战点添加进去
            for (let i = 0; i < moves.length; i++) {
                if (moves[i].stone == this.recommendStone[this.recommendStone.length - 1].stone) {
                    childrenFlag = true
                    break
                }
            }
            if (!childrenFlag) {
                moves.push(this.recommendStone[this.recommendStone.length - 1])
            }
            //end

            for (let i = 0; i < moves.length; i++) {
                const item = moves[i];
                var flag = false
                for (let j = 0; j < this.recommendStone.length; j++) {
                    const element = this.recommendStone[j];
                    if (element.stone == item.stone) {
                        flag = true
                        break
                    }
                }

                if (item.stone == stone && flag) {
                    nodes = item.nodes
                    isBranch = true
                    this.recommendStoneFlag = true
                    this.recommendStoneSelected = item.stone
                }
            }
            if (isBranch) {
                nodes = nodes.split(",")
                this.addRecommendStone(nodes)
            } else {
                return
            }
        },
        addRecommendStone: function (stoneList) {
            if (!this.tryMoveFlag) {
                this.startTryMove()
            }
            if (stoneList) {
                stoneList.forEach(
                    function (val, index) {
                        let stone = this.stoneToPos1(val)
                        this.tryMove.play(stone.X, stone.Y)
                    }.bind(this)
                )
            }
        },
        removeActive() {
            if (this.recommendStoneSelected != "") {
                return
            }
            this.hoverStone = ""
            //这里手机端不触发，会重复关闭
            if (this.tryMoveFlag && (this.platform != "mobile" || this.platform != "ifk_mobile")) {
                this.closeTryMove()
            }
        },
        recommendStoneTop(item) {
            this.recommendStoneFlag = true
            this.hoverStone = "";
            if (item.stone == this.recommendStoneSelected) {
                this.recommendStoneSelected = ""
                this.recommendStoneFlag = false
                if (this.tryMoveFlag) {
                    this.closeTryMove()
                }
            } else {
                this.recommendStoneSelected = item.stone
                this.selectStone(item)
            }
        },
        changeActive(item) {
            if (!this.recommendStoneFlag) {
                this.hoverStone = item.stone
                this.selectStone(item)
            }
        },
        selectStone(item) {
            if (this.scoreFlag) {
                return
            }
            if (this.tryMoveFlag) {
                this.closeTryMove()
            }
            this.addRecommendStone(item.nodes.split(","))
        },
        // 开始试下
        startTryMove() {
            this.moreFlag = false
            this.commentCount = this.player.kifuReader.path.m
            this.oldCurPath = this.player.kifuReader.path.m
            this.tryMoveFlag = true
            this.editable.setPlayType('normal')
            this.trySgf = this.createSgf()
            let tryMoveMarker = {
                markerStyle: 'LB',
                markerNum: 0
            }
            this.marker.switchMaker(tryMoveMarker)
            this.tryMove = new WGo.TryMove(
                this.player,
                this.player.board,
                this.marker
            )
        },
        // 结束试下
        closeTryMove() {
            this.moreFlag = false
            this.tryMoveFlag = false
            this.tryMove.endTry()
            this.tryMove = null
            if (this.oldMarker == null) {
                this.oldMarker = {
                    markerNum: 1,
                    markerStyle: 'CR',
                    start: 0
                }
            }
            this.marker.switchMaker(this.oldMarker)
        },
        //退出分支状态
        backend() {
            if (this.tryMoveFlag) {
                this.closeTryMove()
                this.hoverStone = ""
                this.recommendStoneSelected = ""
                this.recommendStoneFlag = false
                this.board_mouse = ""
            }
        },
        // TAB 切换
        openChart(index) {
            this.backend();
            this.moreFlag = false
            this.tabActive = index
            this.$nextTick(() => {
                if (this.tabActive == 1) {
                    this.chartTrend.resize()
                } else if (this.tabActive == 2) {
                    this.badHand.resize()
                    this.loadBadHand()
                } else if (this.tabActive == 3) {
                    this.hitHand.resize()
                    this.loadHitHand()
                } else if (this.tabActive == 20) { // 棋谱用时
                    this.chartMoveTimes.resize()
                    this.loadMoveTimes()
                }else if (this.tabActive == 21) { // 决策质量
                    this.decisionQuality.resize()
                    this.loadDecisionQuality()
                } else if (this.tabActive == 4) {
                    this.scoreChart.resize()
                    this.loadScoreChart()
                } else if (this.tabActive == 5) {
                    if (this.tongjiFlag == 1) {
                        this.stableLine.resize()
                        this.loadStableLine();
                    } else {
                        this.statisticsBox.resize()
                        this.loadDianSan();
                    }
                } else if (this.tabActive == 7) {
                    this.switchBad();
                } else if (this.tabActive == 8) {
                    this.complexChart.resize()
                    this.loadComplex();
                } else if (this.tabActive == 9) {
                    this.switchGood();
                }
            })
        },
        //切换 全盘 布局 中盘 官子
        boardTypeChange(type) {
            this.boardType = type
            if (this.boardType == 0) {
                this.minHand = 0;
                this.maxHand = this.allPath;
            } else if (this.boardType == 1) {
                this.minHand = 0;
                this.maxHand = parseInt(parseInt(this.size * this.size / 6) / 2) * 2;
            } else if (this.boardType == 2) {
                this.minHand = parseInt(parseInt(this.size * this.size / 6) / 2) * 2 + 1;
                this.maxHand = parseInt(parseInt(this.size * this.size / 2) / 2) * 2;
            } else if (this.boardType == 3) {
                this.minHand = parseInt(parseInt(this.size * this.size / 2) / 2) * 2 + 1;
                this.maxHand = this.allPath;
            }

            if (this.tabActive == 2) {
                this.loadBadHand()
            } else if (this.tabActive == 3) {
                this.loadHitHand()
            } else if (this.tabActive == 4) {
                this.loadScoreChart()
            } else if (this.tabActive == 5) {
                this.loadStableLine()
            } else if (this.tabActive == 21) {
                this.loadDecisionQuality()
            }
        },
        //切换 双方 黑方 白方
        playerTypeChange(type) {
            this.playerType = type
            if (this.tabActive == 2) {
                this.loadBadHand()
            } else if (this.tabActive == 7) {
                this.switchBad()
            } else if (this.tabActive == 9) {
                this.switchGood()
            } else if (this.tabActive == 21) {
                this.loadDecisionQuality()
            }
        },
        //恶手分组点击
        badGroupTop(obj) {
            this.showBadGroup = false
            this.badList = []
            var color = 0
            if (this.playerType == 0) {
                color = 0
            } else if (this.playerType == 1) {
                color = -1
            } else if (this.playerType == 2) {
                color = 1
            }
            for (let i = 1; i < this.allPath; i++) {
                var item = this.result.hands[i]
                if (item.level >= 5 && item.color != color) {
                    if (obj.key == "全部") {
                        if(!(item.bad_tag==""&&(item.mark=='疑问'||item.mark=='不妥'))){
                            this.badList.push(item)
                        }
                    } else {
                        if (item.bad_tag == obj.key) {
                            this.badList.push(item)
                        } else if (item.mark == obj.key&&!item.bad_tag) {
                            this.badList.push(item)
                        }
                    }
                }
            }
            this.badList.sort((a, b) => {
                return b.level - a.level
            })
        },
        // 筛选恶手
        switchBad() {
            this.showBadGroup = true
            var group = [],
                color = 0;
            if (this.playerType == 0) {
                color = 0
            } else if (this.playerType == 1) {
                color = -1
            } else if (this.playerType == 2) {
                color = 1
            }
            var count = 0;
            for (let i = 1; i < this.allPath; i++) {
                var item = this.result.hands[i]
                if (item.level >= 5 && item.color != color) {
                    if (item.bad_tag) {
                        count++
                        if (group[item.bad_tag] != undefined) {
                            group[item.bad_tag]['count']++
                        } else {
                            group[item.bad_tag] = {}
                            group[item.bad_tag]['count'] = 1
                        }
                        group[item.bad_tag]['level'] = item.level
                        group[item.bad_tag]['bad_tag'] = item.bad_tag
                    } else if(item.mark!='疑问'&&item.mark!='不妥'){
                        count++
                        if (group[item.mark] != undefined) {
                            group[item.mark]['count']++
                        } else {
                            group[item.mark] = {}
                            group[item.mark]['count'] = 1
                        }
                        group[item.mark]['level'] = item.level
                        group[item.mark]['mark'] = item.mark
                    }
                }
            }
            this.bad_group = []
            this.bad_group.push({ key: "全部", count: count, level: 1, mark: "全部" })
            for (var key in group) {
                this.bad_group.push({ key: key, count: group[key]['count'], level: group[key]['level'], mark: group[key]['mark'], bad_tag: group[key]['bad_tag'] })
            }
            this.bad_group = this.bad_group.sort((a, b) => {
                return a.level - b.level
            })
        },

        //好手分组点击
        GoodGroupTop(obj) {
            this.showGoodGroup = false
            this.goodList = []
            var color = 0
            if (this.playerType == 0) {
                color = 0
            } else if (this.playerType == 1) {
                color = -1
            } else if (this.playerType == 2) {
                color = 1
            }
            for (let i = 1; i < this.allPath; i++) {
                var item = this.result.hands[i]
                if (item.level <= 3 && item.color != color) {
                    if (obj.key == "全部") {
                        this.goodList.push(item)
                    } else {
                        if (item.good_tag == obj.key) {
                            this.goodList.push(item)
                        } else if (item.mark == obj.key) {
                            this.goodList.push(item)
                        }
                    }
                }
            }
            this.goodList.sort((a, b) => {
                return b.level - a.level
            })
        },
        // 筛选好手
        switchGood() {
            this.showGoodGroup = true
            var group = [],
                color = 0;
            if (this.playerType == 0) {
                color = 0
            } else if (this.playerType == 1) {
                color = -1
            } else if (this.playerType == 2) {
                color = 1
            }
            var count = 0;
            for (let i = 1; i < this.allPath; i++) {
                var item = this.result.hands[i]
                if (item.level <= 3 && item.color != color) {
                    count++
                    if (item.good_tag) {
                        if (group[item.good_tag] != undefined) {
                            group[item.good_tag]['count']++
                        } else {
                            group[item.good_tag] = {}
                            group[item.good_tag]['count'] = 1
                        }
                        group[item.good_tag]['level'] = item.level
                        group[item.good_tag]['good_tag'] = item.good_tag
                    } else {
                        if (group[item.mark] != undefined) {
                            group[item.mark]['count']++
                        } else {
                            group[item.mark] = {}
                            group[item.mark]['count'] = 1
                        }
                        group[item.mark]['level'] = item.level
                        group[item.mark]['mark'] = item.mark
                    }
                }
            }
            this.good_group = []
            this.good_group.push({ key: "全部", count: count, level: 1, mark: "全部" })
            for (var key in group) {
                this.good_group.push({ key: key, count: group[key]['count'], level: group[key]['level'], mark: group[key]['mark'], good_tag: group[key]['good_tag'] })
            }
            this.good_group = this.good_group.sort((a, b) => {
                return a.level - b.level
            })
        },

        ListGoTo(item) {
            this.backend();
            this.badActive = item.move
            this.goodActive = item.move
            this.player.goTo(item.move - 1)
        },
        // 切换鹰眼吻合度
        switchEye() {
            if (this.eyeModeFlag == 1) {
                this.eyeModeFlag = 2
                this.eyeModeText = "推荐点模式"
            } else {
                this.eyeModeFlag = 1
                this.eyeModeText = "首选点模式"
            }
            this.loadHitHand()
        },

        //棋谱前进后退按钮
        boardFunc(type) {
            if(type == "infinite") {
                if(this.app_key === 'ifkadmin' || this.app_key === 'ifksmall' || this.app_key === 'ifk_sgfbank'){ 
                    // RN app打开，
                    if (window.ReactNativeWebView) {
                        // app事件，跳转app对应画面
                        window.ReactNativeWebView?.postMessage(
                            JSON.stringify({ nav: 'InfiniteComputing', params: { sgf: this.result.sgf } }),
                        );
                    } else {
                        window.open(`https://shaoer.yikeweiqi.com/ifk/infinite-computing?sgf=${encodeURIComponent(this.result.sgf)}`)
                    }
                }else{
                    window.open(`https://home.yikeweiqi.com/#/analyse?sgf=${encodeURIComponent(this.result.sgf)}`)
                }
                return
            }
            if (type != "more") this.moreFlag = false
            switch (type) {
                case "first":
                    // this.backend();
                    this.player.first();
                    break;
                case "previousfive":
                    // this.backend();
                    var curP = this.player.kifuReader.path.m;
                    this.player.goTo(curP - 5);
                    break;
                case "previous":
                    // this.backend();
                    this.player.previous();
                    break;
                case "next":
                    // this.backend();
                    this.player.next();
                    break;
                case "nextfive":
                    // this.backend();
                    var curP = this.player.kifuReader.path.m;
                    var move = curP + 5;
                    if (move > this.result.hands_count) this.player.next();
                    else this.player.goTo(move);
                    break;
                case "last":
                    // this.backend();
                    var curP = this.player.kifuReader.path.m;
                    if (curP == this.result.hands_count) this.player.next();
                    else this.player.goTo(this.result.hands_count);
                    break;
                case "score":
                    if (this.scoreFlag) {
                        this.closeScore()
                        this.scoreFlag = false
                        this.player.board.addObject(this.hisPos);
                    } else {
                        this.player.board.removeObject(this.hisPos);
                        this.openScore()
                    }
                    break;
                case "marker":
                    if (this.tryMoveFlag) {
                        return
                    }
                    let data = ''
                    if (this.markerType == 'all') {
                        data = {
                            markerNum: 0,
                            markerStyle: 'LB',
                            start: 0
                        }
                        this.markerType = "lastRed"
                    } else if (this.markerType == 'lastRed') {
                        data = {
                            markerNum: 1,
                            markerStyle: 'CR',
                            start: 0,
                        }
                        this.markerType = "lastNumber"
                    } else if (this.markerType == 'lastNumber') {
                        data = {
                            markerNum: 1,
                            markerStyle: 'LB',
                            start: 0
                        }
                        this.markerType = "all"
                    }
                    this.oldMarker = data
                    this.marker.switchMaker(data)
                    break;
                case 'tryMove':
                    if (this.scoreMode) this.closeScore()
                    if (!this.tryMoveFlag) {
                        this.startTryMove()
                    } else {
                        this.hoverStone = ""
                        this.recommendStoneSelected = ""
                        this.recommendStoneFlag = false
                        this.closeTryMove()
                    }
                    break;
                case "menu":
                    break;
                case "more":
                    // if (!this.isPreview) {
                    this.moreFlag = !this.moreFlag
                    // } else {
                    //     if (this.shareFlag == 1) {
                    //         var r = confirm("更多精彩内容，请下载弈客围棋APP");
                    //         if (r == true) {
                    //             this.onConfirm();
                    //         }
                    //     }
                    // }
                    break;
                case "showStone":
                    this.showStone = !this.showStone
                    if (this.showStone) {
                        this.player.board.removeObject(this.hisPos);
                    } else {
                        this.player.board.addObject(this.hisPos);
                    }
                    break;
                case "help":
                    this.btnFlag = false
                    this.helpFlag = true;
                    this.shadeFlag = true;
                    break;
                case "shade":
                    this.shadeFlag = false;
                    this.helpFlag = false;
                    this.btnFlag = false
                    this.tbFlag = false
                    this.commentFlag = false;
                    break;
                case "comment":
                    this.btnFlag = false
                    this.commentFlag = true;
                    this.shadeFlag = true;
                    break;
                case "pdf":
                    this.gopdf2()
                    break;
            }
        },
        //关闭形势判断
        closeScore() {
            if (this.scoreFlag && this.scoreMode) {
                this.scoreFlag = false;
                this.scoreMode.end();
            }
        },
        openScore() {
            let data = {
                sgf: this.getSgf()
            }
            ApiScore(data).then((resScore) => {
                if (resScore.code === 0) {
                    this.scoreRes = resScore.data
                    this.player.setFrozen(true)
                    this.scoreFlag = true
                    this.showScore(this.scoreRes)
                }
            })
        },

        showScore(result) {
            if (this.scoreMode) this.scoreMode = ''
            let ru = this.player.kifuReader.kifu.info['RU']
            if (!ru) {
                ru = 'cn'
            }
            this.scoreMode = new WGo.ScoreMode(this.player, () => {
                if (ru == 'cn') {
                    if (result.km >= 0) {
                        this.scoreResult.km = this.scoreMode.calculateKm(result.km, result.ha);
                    } else {
                        this.scoreResult.km = Math.abs(this.scoreMode.calculateKm(result.km, result.ha));
                    }
                    this.scoreResult.result = result.cn > 0 ? '黑实地领先' + Math.abs(result.cn) + '子' : '白实地领先' + Math.abs(result.cn) +
                        '子';
                } else {
                    this.scoreResult.km = '黑贴' + (isNaN(result.km) ? 7.5 : result.km) + '目';
                    this.scoreResult.result = result.jp > 0 ? '黑实地领先' + Math.abs(result.jp) + '目' : '白实地领先' + Math.abs(result.jp) +
                        '目';
                }
                if (result.rate || result.rate == '0') {
                    this.scoreResult.rate = result.rateDesc
                } else {
                    this.scoreResult.rate = '胜率 黑' + result.black_wr.toFixed(1) + '%' + '白' + result.white_wr.toFixed(1) + '%'
                }
            })
            this.scoreMode.start(result.pos, true)
        },
        // 获取sgf 包含试下
        getSgf() {
            let sgf = ''
            if (this.tryMoveFlag) {
                sgf = this.player.kifu.noSetupsgf(this.player.kifuReader.node)
                let sgfArr = sgf.split(';')
                sgfArr.shift()
                sgfArr.shift()
                let trySgf = sgfArr.join(';')
                sgf = this.trySgf.replace(')', ';') + trySgf
            } else {
                sgf = this.createSgf()
            }
            return sgf
        },
        // 生成sgf
        createSgf: function () {
            let KM = this.player.kifuReader.kifu.info['KM']
            let HA = this.player.kifuReader.kifu.info['HA']
            KM = HA > 0 ? 0 : KM
            let sgf = this.player.kifuReader.kifu.scoreSgf(
                this.player.kifuReader.node,
                KM,
                HA
            )
            return sgf
        },
        //加载棋局走势
        loadTrend() {
            let move = [],
                wr = [],
                an = [],
                whitewr = [],
                max = 0;
            for (let i = 0; i <= this.allPath; i++) {
                const hand = this.moves[i];
                if (Math.abs(hand.an_result) > max) {
                    max = Math.abs(hand.an_result)
                }
                move.push(hand.move);
                wr.push(hand.b_rate);
                an.push(hand.an_result)
                whitewr.push(hand.w_rate);
            }
            max = Math.max(2 * (Math.ceil(max / 2) + 1), 10)
            this.chartTrend.on('click', function (params) {
                this.player.goTo(params.dataIndex)
            }.bind(this));
            var interval = 0
            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                interval = move.length / 6
            } else {
                interval = 19
            }
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let str = "手数：" + e[0].dataIndex + "</br>";
                        for (let i = 0; i < e.length; i++) {
                            str = str + e[i].seriesName + "：" + e[i].value.toFixed(1);
                            if (e[i].seriesName != "目差") {
                                str += "%"
                            }
                            str = str + "</br>"
                        }
                        if (this.driveType == 1) {
                            this.player.goTo(e[0].dataIndex)
                        }
                        return str
                    }.bind(this)
                },
                // dataZoom: [
                //     {
                //     type: 'slider',
                //     show: true,
                //     showDetail:false,
                //     height:5,
                //     bottom:10,
                //     xAxisIndex: [0],
                //     start: 1,
                //     end: 20
                //     },
                //      {
                //     type: 'inside',
                //     xAxisIndex: [0],
                //     start: 1,
                //     end: 35
                //     },
                // ],
                grid: this.style.trendgrid,
                axisPointer: {
                    type: 'line',
                    lineStyle: {
                        color: '#f86747',
                    },
                },
                graphic: [{
                    type: 'text',
                    id: 'desc',
                    right: 'center',
                    top: 40,
                    z: -10,
                    bounding: 'raw',
                    originX: 75,
                    originY: 75,
                },],
                legend: {
                    top: this.style.legendTop,
                    data: ['黑胜率', '白胜率', '目差'],
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize,
                    },
                    selected: {
                        // 选中'系列1'
                        '黑胜率': true,
                        '白胜率': false,
                        // 不选中'系列2'
                        '目差': true
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: move,
                    axisLabel: {
                        interval: parseInt(interval), //间隔,
                        fontSize:this.style.fontsize,
                    },
                    nameTextStyle: {
                        color: this.style.color
                    },
                    max: this.allPath,
                    axisLine: {
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: [{
                    name: '(%)',
                    type: 'value',
                    max: 100,
                    min: 0,
                    splitNumber: 2,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: this.style.color
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color,
                            width: 0.5
                        }
                    },
                    axisLabel: {
                        show: true,
                        fontSize:this.style.fontsize,
                    },
                },
                {
                    name: '(目)',
                    type: 'value',
                    splitNumber: 1,
                    max: max,
                    min: -max,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: this.style.color
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color,
                            width: 0.5
                        }
                    },
                    axisLabel: {
                        show: true,
                        fontSize:this.style.fontsize,
                    },
                }
                ],
                series: [
                    {
                        name: '黑胜率',
                        type: 'line',
                        data: wr,
                        symbolSize: 0,
                        symbol: "none",
                        itemStyle: {
                            barBorderRadius: 30,
                            color: '#E0534C'
                        },
                        z: 2,
                        smooth: true,
                    },
                    {
                        name: '白胜率',
                        type: 'line',
                        data: whitewr,
                        symbolSize: 0,
                        symbol: "none",
                        itemStyle: {
                            barBorderRadius: 30,
                            color: '#3F85C5'
                        },
                        z: 2,
                        smooth: true,
                    },
                    {
                        yAxisIndex: 1,
                        name: '目差',
                        type: 'line',
                        data: an,
                        symbolSize: 0,
                        symbol: "none",
                        itemStyle: {
                            barBorderRadius: 30,
                            color: '#59E04E'
                        },
                        smooth: true,
                        z: 1,
                    },
                ]
            };
            this.chartTrend.setOption(option);
            this.chartTrend.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.chartTrend.containPixel('grid', pointInPixel)) {
                    let xIndex = this.chartTrend.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(xIndex)
                }
            });
        },
        // 决策质量
        loadDecisionQuality(){
            const data  = {
                "good": [0,0,0,0,0],
                "normal": [0,0,0,0,0],
                "bad": [0,0,0,0,0],
                "names": [
                    "秒拍",
                    "速决",
                    "普通",
                    "深思",
                    "长考"
                ]
            }
            const good_tags = ['超神', '首选', '很好']
            const normal_tags = ['可行', '疑问', '不妥']
            let max = 0
            function addData(hand, index){
                if(good_tags.includes(hand.mark)){
                    data.good[index]++
                    if(data.good[index] > max){
                        max = data.good[index]
                    }
                }else if(normal_tags.includes(hand.mark)){
                    data.normal[index]++
                    if(data.normal[index] > max){
                        max = data.normal[index]
                    }
                }else{
                    data.bad[index]++
                    if(data.bad[index] > max){
                        max = data.bad[index]
                    }
                }
            }
            for (let i = 0; i < this.allPath; i++) {
                if (i >= this.minHand && i <= this.maxHand) {
                    const hand = this.moves[i];
                    // 看白方
                    if((this.playerType == 2 && hand.color == -1) || (this.playerType != 2 && hand.color == 1)){
                        if(hand.move_time < 4){
                            addData(hand, 0)
                        }else if(hand.move_time >= 4 && hand.move_time < 9){
                            addData(hand, 1)
                        }else if(hand.move_time >= 9 && hand.move_time < 16){
                            addData(hand, 2)
                        }else if(hand.move_time >= 16 && hand.move_time < 31){
                            addData(hand, 3)
                        }else{
                            addData(hand, 4)
                        }
                    }
                }
            }
         
            max = Math.ceil(max / 5) * 5 + 5
            let paddingWidth = 40
            let fontSize = 11;
            let xLabelFontSize = 12;
            if (this.platform == "mobile" || this.platform=="ifk_mobile") {
                paddingWidth = 20
                fontSize = 8
                xLabelFontSize = 9
            } 
            const chartWidth = this.decisionQuality.getWidth() / data.names.length - paddingWidth
            const richItem = {
                borderRadius: 3,
                fontSize: xLabelFontSize,
                backgroundColor: this.stdevColor[0],
                color: '#fff',
                width: chartWidth,
                padding: [3, 0]
            }
            if(this.platform == "ifk_mobile"){
                fontSize = 7
            }
            const showTextStyle = {
                color: '#f7f7f7',
                fontSize: fontSize
            }
            function formatter (a) {
                const total = data.good[a.dataIndex] + data.normal[a.dataIndex] + data.bad[a.dataIndex]
                if(a.value == 0 || total == 0){
                    return ''
                }
                return a.value + '\n '+(Math.round(a.value/total*100)).toFixed(0)+'%'
            }
            if (this.platform == "mobile") {
                showTextStyle.color = '#000'
            }
            
            const option = {
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                },
                calculable: true,
                legend: {
                    top: this.style.legendTop,
      
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize,
                    },
                  data: ['优', '中', '差'],
                },
                grid: {
                  top: '20%',
                  left: '1%',
                  right: '5%',
                  bottom: '10%',
                  containLabel: true
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    axisLabel: {
                        formatter: function (value, index) {
                            return '{value'+index+'|' + value + '}';
                        },
                        interval: 0,
                        // margin: 20,
                        rich: {
                            value0: richItem,
                            value1: {
                                ...richItem,
                                backgroundColor: this.stdevColor[1],
                            },
                            value2: {
                                ...richItem,
                                backgroundColor: this.stdevColor[2],
                            },
                            value3: {
                                ...richItem,
                                backgroundColor: this.stdevColor[3],
                            },
                            value4: {
                                ...richItem,
                                backgroundColor: this.stdevColor[4],
                            },
                        }
                    },
                    data: data.names
                },
                yAxis: {
                    max: max,
                    nameTextStyle: {
                        color: "#a9a6ae",
                    },
                    axisLabel: {
                        show: true,
                        fontSize:this.style.fontsize,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    type: 'value',
                    
                  },
                
                series: [
                  {
                    name: '优',
                    type: 'bar',
                    itemStyle: {
                        color: '#248E35'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: showTextStyle,
                        formatter: formatter
                    },
                    data: data.good
                  },
                  {
                    name: '中',
                    type: 'bar',
                    itemStyle: {
                        color: '#DCB41E'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: showTextStyle,
                        formatter: formatter
                    },
                    data: data.normal
                  },
                  {
                    name: '差',
                    type: 'bar',
                    itemStyle: {
                        color: '#DC0000'
                    },
                    label: {
                        show: true,
                        textStyle: showTextStyle,
                        position: 'top',
                        formatter: formatter
                    },
                    data: data.bad
                  },
                ]
              };
              this.decisionQuality.setOption(option);
        },
        // 加棋谱用时
        loadMoveTimes(){
            let move = [],
                maxComplexity = 0, // 复杂度最大
                b_times = [],
                w_times = [],
                stdev = [],
                max = 0;

            for (let i = 1; i <= this.allPath; i++) {
                const hand = this.moves[i];
                if(hand.color == 1){
                    b_times.push([i-1, hand.move_time])
                    // w_times.push(0)
                }else{
                    w_times.push([i-1, hand.move_time])
                    // b_times.push(0)
                }
                // 复杂度
                if (hand.score_stdev > maxComplexity) {
                    maxComplexity = hand.score_stdev;
                }
                if (hand.move_time > max) {
                    max = hand.move_time
                }
                stdev.push(hand.score_stdev);
                move.push(hand.move);
            }
            // 复杂度最大值
            maxComplexity = Math.ceil(maxComplexity / 4) * 4
            
            // 用时最大值
            max = Math.ceil(max / 20) * 20
            var interval = 0
            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                interval = move.length / 6
            } else {
                interval = 19
            }

            const legendData = []
            const yAxis = []
            const series = []
            if(this.moveTimes){
                legendData.push('黑用时', '白用时')
                yAxis.push({
                    name: '(秒)',
                    type: 'value',
                    max: max,
                    min: 0,
                    splitNumber: 4,
                    interval: max / 4,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: this.style.color
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color,
                            width: 0.5
                        }
                    },
                    axisLabel: {
                        show: true,
                        fontSize:this.style.fontsize,
                    },
                })
                series.push({
                    name: '黑用时',
                    type: 'line',
                    data: b_times,
                    symbolSize: 0,
                    symbol: "none",
                    itemStyle: {
                        barBorderRadius: 30,
                        color: '#e0534c'
                    },
                    z: 2,
                    smooth: true,
                },
                {
                    name: '白用时',
                    type: 'line',
                    data: w_times,
                    symbolSize: 0,
                    symbol: "none",
                    itemStyle: {
                        barBorderRadius: 30,
                        color: '#3F85C5'
                    },
                    smooth: true,
                    z: 1,
                })
            }
            if(this.reportType == 1){
                legendData.push('复杂度')
                yAxis.push({
                    name: '复杂度',
                    type: 'value',
                    max: maxComplexity,
                    min: 0,
                    interval: this.moveTimes ? maxComplexity  : maxComplexity / 4,
                    splitNumber: 4,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: this.style.color
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    splitLine: {
                        show: true,
                        // interval:2,
                        // lineStyle: {
                        //     color: this.style.color,
                        //     width: 0.5
                        // }
                    }
                })
                series.push( {
                    yAxisIndex: this.moveTimes ? 1 : 0, // 是否使用第二个y轴
                    name: '复杂度',
                    type: 'line',
                    data: stdev,
                    symbolSize: 0,
                    symbol: "none",
                    itemStyle: {
                        barBorderRadius: 30,
                        color: '#59E04E'
                    },
                    z: 3,
                    smooth: true,
                })
            }
           
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let str = "第" + e[0].axisValue + "手</br>";
                        for (let i = 0; i < e.length; i++) {
                            if (e[i].seriesName == '复杂度') {
                                str = str + e[i].seriesName + "：" + e[i].value.toFixed(1);
                            }else{
                                str = str + e[i].seriesName + "：" + e[0].value[1].toFixed(0);
                                str += "秒"
                            }
                            str = str + "</br>" 
                        }
                        return str
                    }.bind(this)
                },
                grid: this.style.trendgrid,
                axisPointer: {
                    type: 'line',
                    lineStyle: {
                        color: '#f86747',
                    },
                },
                graphic: [{
                    type: 'text',
                    id: 'desc',
                    right: 'center',
                    top: 40,
                    z: -10,
                    bounding: 'raw',
                    originX: 75,
                    originY: 75,
                },],
                legend: {
                    top: this.style.legendTop,
                    data: legendData,
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize,
                    },
                    selected: {
                        // 选中'系列1'
                        '黑用时': true,
                        '复杂度': true,
                        // 不选中'系列2'
                        '白用时': true
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: move,
                    axisLabel: {
                        interval: parseInt(interval), //间隔,
                        fontSize:this.style.fontsize,
                    },
                    nameTextStyle: {
                        color: this.style.color
                    },
                    max: this.allPath,
                    axisLine: {
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: yAxis,
                series: series
            };
            this.chartMoveTimes.setOption(option);
            this.chartMoveTimes.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.chartMoveTimes.containPixel('grid', pointInPixel)) {
                    let xIndex = this.chartMoveTimes.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(xIndex + 1)
                }
            });
        },
        //加载恶手分析
        loadBadHand() {
            var _this = this;
            var dataarr = [],
                color = 0;
            if (this.playerType == 0) {
                color = 0
            } else if (this.playerType == 1) {
                color = -1
            } else if (this.playerType == 2) {
                color = 1
            }
            for (let i = 1; i < this.allPath; i++) {
                var item = this.result.hands[i]
                if (item.level >= 5 && item.color != color && item.move > this.minHand && item.move <= this.maxHand) {
                    dataarr.push(item)
                }
            }
            dataarr = dataarr.sort((a, b) => {
                return a.bad_sort - b.bad_sort
            })
            dataarr = dataarr.slice(0, 10)
            dataarr.sort((a, b) => {
                return a.move - b.move
            })
            let hands = [], series = [];
            for (let i = 0; i < dataarr.length; i++) {
                let item = dataarr[i]
                hands.push(item.move)
                series.push([i, item.cur_rate.toFixed(1), item.pre_rate.toFixed(1), item.color, item.an_diff.toFixed(1), "", item.move, item.rate_diff.toFixed(0)])
            }
            this.badHand.on('click', function (params) {
                this.player.goTo(params.data[6] - 1)
            }.bind(this));
            let distance = 0;
            let fontSize = 0;
            let  symbolOffset=[0,0];
            if (this.platform == "mobile") {
                this.style.axisTick = { //坐标轴刻度线
                    length: 2,
                    alignWithLabel: true,
                    lineStyle: {
                        color: this.style.color,
                        width: 0.5
                    }
                }
                distance = 8;
                fontSize = 10;
                symbolOffset=[0, -55]
            } else if(this.platform=="ifk_mobile"){
                this.style.axisTick = { //坐标轴刻度线
                    length: 2,
                    alignWithLabel: true,
                    lineStyle: {
                        color: this.style.color,
                        width: 0.5
                    }
                }
                distance = 25;
                fontSize = 10;
                symbolOffset=[0, -20]
            }else {
                this.style.axisTick = {
                    length: 2,
                    inside: true,
                    alignWithLabel: true,
                    lineStyle: {
                        color: this.style.color,
                        width: 0.5
                    }
                }
                distance = 10;
                fontSize = 12;
                symbolOffset=[0, -75]
            }

            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                        type: 'line',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let item = e[0]
                        let str = _this.result.hands[item.axisValue].mark + "</br>";
                        str = str + "手数: " + item.axisValue + "</br>";
                        str = str + "胜率: " + item.value[2] + " -> " + item.value[1];
                        str = str + "</br>";
                        if (item.value[4] <= 0) {
                            str = str + "目差: 亏损 " + Math.abs(item.value[4]) + " 目";
                        } else {
                            str = str + "目差: 增加 " + item.value[4] + " 目";
                        }
                        return str
                    }.bind(this)
                },
                grid: this.style.badhandgrid,
                legend: {
                    textStyle: {
                        fontSize: this.style.fontsize
                    }
                },
                xAxis: {
                    axisLine: { //坐标轴轴线
                        lineStyle: {
                            color: this.style.color
                        },
                    },
                    data: hands,
                    axisTick: this.style.axisTick,
                    axisLabel: {
                        show: true,
                        fontSize: () => {
                            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                                return 10
                            } else {
                                return 14
                            }
                        },
                    },
                    boundaryGap: true
                },
                yAxis: {
                    show: this.style.bandYshow,
                    type: 'value',
                    min: 0,
                    max: 100,
                    splitNumber: 2,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: "#a9a6ae",
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#a9a6ae",
                        }
                    },
                    splitLine: {
                        show: false,
                    }
                },
                series: [{
                    symbol: (value, params) => {
                        var stone = _this.result.hands[value[6]]
                        var platform = ""
                        if (_this.platform == "mobile") {
                            platform = "m"
                        }
                        if(_this.platform=="ifk_mobile"){
                            platform = "ifk"
                          
                        }

                        if (stone.color == 1) {
                            return 'image://' + require('@/assets/face/' + platform + 'b' + stone.level + '.png')
                        } else {
                            return 'image://' + require('@/assets/face/' + platform + 'w' + stone.level + '.png')
                        }
                    },
                    label: {
                        show: true,
                        position: "insideBottom",
                        distance: distance, // 正 上移
                        textStyle: {
                            color: '#f7f7f7',
                            fontWeight: '600',
                            fontSize: fontSize
                        },
                        formatter: function (data) {
                            return  Math.abs(data.data[7]);
                        }
                    },
                    symbolSize: () => {
                        if (this.platform == "mobile") {
                            return [24, 120]
                        } else if(this.platform=="ifk_mobile"){
                            return [24, 56]
                        } else {
                            return [33, 165]
                        }
                    },
                    symbolOffset:symbolOffset,
                    data: series,
                    type: 'scatter',
                }]
            };
            this.badHand.setOption(option);
            this.badHand.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.badHand.containPixel('grid', pointInPixel)) {
                    let xIndex = this.badHand.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(hands[xIndex] - 1)
                }
            });
        },
        //加载吻合度
        loadHitHand() {
            let bArr = [], wArr = [], b = 0, w = 0;
            for (let i = 1; i <= this.allPath; i++) {
                if (i >= this.minHand && i <= this.maxHand) {
                    var item = this.result.hands[i]
                    var flag = false;
                    if (this.eyeModeFlag == 1) {
                        flag = item.main_hit
                    } else {
                        flag = item.branch_hit
                    }
                    if (item.color == 1) {
                        if (flag) b++
                        bArr.push([i, 4, flag]);
                        wArr.push([i, 2, false]);
                    } else {
                        if (flag) w++
                        bArr.push([i, 4, false]);
                        wArr.push([i, 2, flag]);
                    }
                }
            }
            let tempC = this.result.hands[this.allPath].color
            // 黑棋=本局最后一手颜色*取上整（区间手数/2*本局最后一手颜色）
            // 白棋=本局最后一手颜色*取整（区间手数/2*本局最后一手颜色）
            this.bw = (b / (tempC * Math.ceil((bArr.length ) / 2 * tempC)) * 100).toFixed(1) + "%"
            this.ww = (w / (tempC * Math.floor((wArr.length) / 2 * tempC)) * 100).toFixed(1) + "%"
            this.hitHand.on('click', function (params) {
                this.player.goTo(params.data[0])
            }.bind(this));

            let option = {
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        return "第" + (e[0].data[0]) + "手";
                    }.bind(this)
                },
                grid: {
                    left: '12%',
                    right: '8%',
                    top: '20%',
                    bottom: '17%',
                },
                legend: {
                    top: this.style.legendTop,
                    data: ['黑棋', '白棋'],
                    formatter: function (name) {
                        if (name == "黑棋") {
                            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                                return "黑:" + this.bw
                            } else {
                                return "黑棋吻合度：" + this.bw
                            }
                        } else {
                            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                                return "白:" + this.ww
                            } else {
                                return "白棋吻合度：" + this.ww
                            }
                        }
                    }.bind(this),
                    selectedMode: false,
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize
                    },
                },
                xAxis: {
                    min: this.minHand,
                    max: this.maxHand,
                    minInterval: 1,
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisLabel: {
                        show: true,
                        Color: this.style.color
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    max: 5,
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        formatter: function (value) {
                            if (value == 4) {
                                return "{a|黑棋}"
                            } else if (value == 2) {
                                return "{a|白棋}"
                            }
                        },
                        rich: {
                            a: {
                                color: this.style.color,
                            },
                        }
                    }
                },
                series: [
                    {
                        emphasis: {
                            focus: 'self',
                            blurScope: 'global'
                        },
                        name: "黑棋",
                        symbol: 'roundRect',
                        symbolSize: function (data) {
                            if (data[2] == false) {
                                return 1
                            } else {
                                return [this.aiSize, 20]
                            }
                        }.bind(this),
                        data: bArr,
                        type: 'scatter',
                        itemStyle: {
                            color: "#e0534c"
                        },
                    }, {
                        emphasis: {
                            focus: 'self',
                            blurScope: 'global'
                        },
                        name: "白棋",
                        symbol: 'roundRect',
                        symbolSize: function (data) {
                            if (data[2] == false) {
                                return 1
                            } else {
                                return [this.aiSize, 20]
                            }
                        }.bind(this),
                        data: wArr,
                        type: 'scatter',
                        itemStyle: {
                            color: "#3F85C5"
                        }
                    }]
            };
            this.hitHand.setOption(option)
            this.hitHand.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.hitHand.containPixel('grid', pointInPixel)) {
                    let xIndex = this.hitHand.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(Math.round(xIndex))
                }
            });
        },
        //稳定性 折线图 散点图切换
        switchTongji() {
            if (this.tongjiFlag == 1) {
                this.tongjiFlag = 2
                this.tongjiText = "折线图"
                this.$nextTick(() => {
                    this.statisticsBox.resize()
                    this.loadDianSan()
                })
            } else {
                this.tongjiFlag = 1
                this.tongjiText = "散点图"
                this.$nextTick(() => {
                    this.statisticsBox.resize()
                    this.loadStableLine()
                })
            }
        },
        // 加载稳定性点散图
        loadDianSan() {
            let data = [
                [[-this.result.total.b_avg, Math.sqrt(this.result.total.b_var)]],
                [[-this.result.total.w_avg, Math.sqrt(this.result.total.w_var)]]
            ];
            //X最大值为 = Max{ 2*( ceil[ Max(黑平均目数亏损, 白平均目数亏损)/ 2] + 1) ,2}
            let xMax = Math.max(2 * (Math.ceil((Math.max(-(this.result.total.b_avg), -(this.result.total.w_avg)) / 2)) + 1), 2)
            //  Y最大值=Max{ 2*( ceil[ Max(黑标准差, 白标准差)/ 2] + 1) , 4}
            let yMax = Math.max(2 * (Math.ceil(Math.max(Math.sqrt(this.result.total.b_var), Math.sqrt(this.result.total.w_var)) / 2) + 1), 4)
            var option = {
                grid: {
                    show: true,
                    borderWidth: 1,
                    borderColor: this.style.color,
                    containLabel: true, //grid 区域是否包含坐标轴的刻度标签，
                    backgroundColor: "transparent", //标题背景色
                    left: '5%',
                    right: '5%',
                    top: '25%',
                    bottom: '17%',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (params, ticket, callback) {
                        let str = "标准差：" + params[0].value[1].toFixed(1) + '<br/>' + "平均目数亏损：" + params[0].value[0].toFixed(1)
                        return str;
                    }
                },
                toolbox: {
                    show: false,
                    feature: {
                        restore: {
                            show: true
                        },
                        saveAsImage: {
                            show: true
                        }
                    }
                },
                legend: {
                    top: this.style.legendTop,
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize
                    },
                    data: ['黑棋水平', '白棋水平']
                },
                xAxis: {
                    min: 0,
                    max: xMax,
                    interval: 2,
                    axisLine: {
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    inverse: true
                },
                yAxis: [{
                    gridIndex: 0,
                    min: 0,
                    max: yMax,
                    interval: 2,
                    axisLine: {
                        lineStyle: {
                            color: this.style.color
                        }
                    }, //去除刻度
                    axisTick: {
                        show: false
                    }, //去除刻度
                    splitLine: {
                        show: false
                    }, //去除网格线
                    inverse: true
                }],
                series: [{
                    name: '黑棋水平',
                    data: data[0],
                    type: 'scatter',
                    symbolSize: 28, //圆点大小
                    label: {
                        emphasis: {
                            show: false,
                            formatter: function (param) {
                                return "平均目数亏损：" + param.data[0] + ",标准差：" + param.data[1];
                            },
                            position: 'top'
                        }
                    },
                    markLine: {
                        data: [{
                            name: 'Y 轴值的水平线',
                            yAxis: Math.ceil(yMax / 2),
                            lineStyle: {
                                color: "#808080"
                            }
                        }, {
                            name: 'X 轴值的水平线',
                            xAxis: -4,
                            lineStyle: {
                                color: "#808080"
                            }
                        }],
                        label: {
                            show: false
                        },
                        symbol: 'none',
                        itemStyle: {
                            lineStyle: {
                                color: '#000',
                                width: 1,
                                type: 'solid'
                            }
                        }
                    },
                    itemStyle: {
                        color: 'black',
                        borderWidth: 1,
                        borderColor: 'white'
                    }
                }, {
                    name: '白棋水平',
                    data: data[1],
                    type: 'scatter',
                    symbolSize: 30,
                    label: {
                        emphasis: {
                            show: false,
                            formatter: function (param) {
                                return "平均目数亏损：" + param.data[0] + ",标准差：" + param.data[1];
                            },
                            position: 'top'
                        }
                    },
                    itemStyle: {
                        color: '#dcdcdc',
                    },
                    markLine: {
                        data: [{
                            name: 'Y 轴值的水平线',
                            yAxis: 9,
                            lineStyle: {
                                color: "#808080"
                            }

                        }, {
                            name: 'X 轴值的水平线',
                            xAxis: -4,
                            lineStyle: {
                                color: "#808080"
                            }
                        }],
                        label: {
                            show: false
                        },
                        symbol: 'none',
                        itemStyle: {
                            lineStyle: {
                                color: '#000',
                                width: 1,
                                type: 'solid'
                            }
                        }
                    },
                }]
            };
            this.statisticsBox.setOption(option);
        },
        // 加载稳定折线图
        loadStableLine() {
            // an_diff
            let barr = [], warr = [];
            let handCount = 0;
            let b_avg = 0, w_avg = 0;
            for (var i = 1; i <= this.allPath; i++) {
                if (i >= this.minHand && i <= this.maxHand) {
                    handCount++
                    if (this.moves[i].move % 2 == 1) {
                        let score = 0;
                        for (var j = this.minHand; j <= i; j++) {
                            if (this.moves[j].move % 2 == 1) {
                                score += -this.moves[j].an_diff
                            }
                        }
                        let pushB = score / (parseInt((handCount + 1) / 2))
                        barr.push([i, pushB])
                        if (pushB > b_avg) {
                            b_avg = pushB
                        }
                    }
                    if (this.moves[i].move % 2 == 0) {
                        let score = 0;
                        for (var j = this.minHand; j <= i; j++) {
                            if (this.moves[j].move % 2 == 0) {
                                score += -this.moves[j].an_diff
                            }
                        }
                        let pushW = score / (parseInt((handCount + 1) / 2))
                        warr.push([i, pushW])
                        if (pushW > w_avg) {
                            w_avg = pushW
                        }
                    }
                }
            }
            var wAllScore = [], bAllScore = [];
            if (warr.length > 0) {
                wAllScore = warr[warr.length - 1][1]
            } else {
                wAllScore = 0
            }
            if (barr.length > 0) {
                bAllScore = barr[barr.length - 1][1]
            } else {
                bAllScore = 0
            }

            //X最大值为 = Max{ 2*( ceil[ Max(黑平均目数亏损, 白平均目数亏损)/ 2] + 1) ,4 }
            let xMax = Math.max(2 * ((Math.ceil(Math.max(b_avg, w_avg) / 2)) + 1), 2)

            var arrTemp = [], allScoreTemp = [];
            if (this.player.kifu.info.KM == 0 || this.player.kifu.info.HA > 0) {
                arrTemp = barr
                barr = warr
                warr = arrTemp
                allScoreTemp = bAllScore
                bAllScore = wAllScore
                wAllScore = allScoreTemp
            }

            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let str = "手数：" + e[0].value[0] + "</br>";
                        str = str + e[0].seriesName + "：" + e[0].value[1].toFixed(1);
                        return str
                    }.bind(this)
                },
                title: {
                    text: '平均目数损失',
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize
                    },
                },
                grid: this.style.stablegrid,
                legend: {
                    top: this.style.legendTop,
                    data: ['黑棋亏损', '白棋亏损'],
                    formatter: function (name) {
                        if (name == "黑棋亏损") {
                            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                                return "黑:" + bAllScore.toFixed(1)
                            } else {
                                return "黑棋：" + bAllScore.toFixed(1)
                            }
                        } else {
                            if (this.platform == "mobile"||this.platform=="ifk_mobile") {
                                return "白:" + wAllScore.toFixed(1)
                            } else {
                                return "白棋：" + wAllScore.toFixed(1)
                            }
                        }
                    }.bind(this),
                    selectedMode: false,
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize
                    },
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisTick: {
                        show: false,
                    },
                    min: this.minHand,
                    max: this.maxHand,
                },
                yAxis: {
                    min: 0,
                    max: xMax,
                    type: 'value',
                    // interval: xMax / 2,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#a9a6ae",
                            width: 0.5
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [{
                    name: "黑棋亏损",
                    data: barr,
                    type: 'line',
                    smooth: true,
                    showSymbol: false,
                    itemStyle: {
                        color: "#e0534c"
                    }
                }, {
                    name: "白棋亏损",
                    data: warr,
                    type: 'line',
                    smooth: true,
                    showSymbol: false,
                    itemStyle: {
                        color: "#3F85C5"
                    }
                }]
            };
            this.stableLine.setOption(option);
            this.stableLine.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.stableLine.containPixel('grid', pointInPixel)) {
                    let xIndex = this.stableLine.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(Math.round(xIndex) - 1)
                }
            });
        },

        // 加载评分
        loadScoreChart() {
            let barr = [], warr = [];
            let handCount = 0;
            for (var i = 1; i <= this.allPath; i++) {
                if (i >= this.minHand && i <= this.maxHand) {
                    handCount++
                    if (this.moves[i].move % 2 == 1) {
                        let score = 0;
                        for (var j = this.minHand; j <= i; j++) {
                            if (this.moves[j].move % 2 == 1) {
                                score += this.moves[j].score
                            }
                        }
                        barr.push([i, score / (parseInt((handCount + 1) / 2))])
                    }
                    if (this.moves[i].move % 2 == 0) {
                        let score = 0;
                        for (var j = this.minHand; j <= i; j++) {
                            if (this.moves[j].move % 2 == 0) {
                                score += this.moves[j].score
                            }
                        }
                        warr.push([i, score / (parseInt((handCount + 1) / 2))])
                    }
                }
            }
            var wAllScore = [], bAllScore = [];
            if (warr.length > 0) {
                wAllScore = warr[warr.length - 1][1]
            } else {
                wAllScore = 0
            }
            if (barr.length > 0) {
                bAllScore = barr[barr.length - 1][1]
            } else {
                bAllScore = 0
            }

            var arrTemp = [], allScoreTemp = [];
            if (this.player.kifu.info.KM == 0 || this.player.kifu.info.HA > 0) {
                arrTemp = barr
                barr = warr
                warr = arrTemp
                allScoreTemp = bAllScore
                bAllScore = wAllScore
                wAllScore = allScoreTemp
            }

            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let str = "手数：" + e[0].value[0] + "</br>";
                        str = str + e[0].seriesName + "：" + e[0].value[1].toFixed(1);
                        return str
                    }.bind(this)
                },
                grid: this.style.scoregrid,
                legend: {
                    top: this.style.legendTop,
                    data: ['黑棋评分', '白棋评分'],
                    formatter: function (name) {
                        if (name == "黑棋评分") {
                            if (this.platform == "mobile") {
                                return "黑评分:" + bAllScore.toFixed(1)
                            } else {
                                return "黑棋评分：" + bAllScore.toFixed(1)
                            }
                        } else {
                            if (this.platform == "mobile") {
                                return "白评分:" + wAllScore.toFixed(1)
                            } else {
                                return "白棋评分：" + wAllScore.toFixed(1)
                            }
                        }
                    }.bind(this),
                    selectedMode: false,
                    textStyle: {
                        color: this.style.color,
                        fontSize: this.style.fontsize
                    },
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisTick: {
                        show: false,
                    },
                    min: this.minHand,
                    max: this.maxHand,
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#a9a6ae",
                            width: 0.5
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: { color: this.style.color, }
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [{
                    name: "黑棋评分",
                    data: barr,
                    type: 'line',
                    smooth: true,
                    showSymbol: false,
                    itemStyle: {
                        color: "#e0534c"
                    }
                }, {
                    name: "白棋评分",
                    data: warr,
                    type: 'line',
                    smooth: true,
                    showSymbol: false,
                    itemStyle: {
                        color: "#3F85C5"
                    }
                }]
            };
            this.scoreChart.setOption(option);
            this.scoreChart.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.scoreChart.containPixel('grid', pointInPixel)) {
                    let xIndex = this.scoreChart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(Math.round(xIndex))
                }
            });
        },


        //加载复杂度
        loadComplex() {
            let move = [],
                stdev = [],
                max = 0;
            for (let i = 0; i < this.allPath; i++) {
                const hand = this.moves[i];
                if (hand.score_stdev > max) {
                    max = hand.score_stdev;
                }
                move.push(hand.move);
                stdev.push(hand.score_stdev);
            }
            if (Math.ceil(max) % 2 == 1) {
                max = Math.ceil(max) + 3
            } else {
                max = Math.ceil(max) + 2
            }
            this.complexChart.on('click', function (params) {
                this.player.goTo(params.dataIndex)
            }.bind(this));
            var interval = 0
            if (this.platform == "mobile") {
                interval = move.length / 6
            } else {
                interval = 19
            }
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        axis: 'x',
                    },
                    backgroundColor: "rgba(20, 20, 20, 0.8)",
                    textStyle: {
                        color: "#fff"
                    },
                    borderWidth: 0,
                    formatter: function (e) {
                        let str = "手数：" + e[0].dataIndex + "</br>";
                        for (let i = 0; i < e.length; i++) {
                            str = str + e[i].seriesName + "：" + e[i].value.toFixed(1);
                            str = str + "</br>"
                        }
                        if (this.driveType == 1) {
                            this.player.goTo(e[0].dataIndex)
                        }
                        return str
                    }.bind(this)
                },
                grid: this.style.trendgrid,
                axisPointer: {
                    type: 'line',
                    lineStyle: {
                        color: '#f86747',
                    },
                },
                graphic: [{
                    type: 'text',
                    id: 'desc',
                    right: 'center',
                    top: 40,
                    z: -10,
                    bounding: 'raw',
                    originX: 75,
                    originY: 75,
                },],
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: move,
                    axisLabel: {
                        interval: parseInt(interval) //间隔
                    },
                    nameTextStyle: {
                        color: this.style.color
                    },
                    max: this.allPath,
                    axisLine: {
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: [{
                    name: '',
                    type: 'value',
                    max: max,
                    min: 0,
                    interval: max / 2,
                    splitNumber: 0,
                    boundaryGap: false,
                    nameTextStyle: {
                        color: this.style.color
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: this.style.color
                        }
                    },
                    splitLine: {
                        show: true,
                        // interval:2,
                        // lineStyle: {
                        //     color: this.style.color,
                        //     width: 0.5
                        // }
                    }
                }],
                series: [
                    {
                        name: '复杂度',
                        type: 'line',
                        data: stdev,
                        symbolSize: 0,
                        symbol: "none",
                        itemStyle: {
                            barBorderRadius: 30,
                            color: '#59E04E'
                        },
                        z: 2,
                        smooth: true,
                    },
                ]
            };
            this.complexChart.setOption(option);
            this.complexChart.getZr().on('click', params => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (this.complexChart.containPixel('grid', pointInPixel)) {
                    let xIndex = this.complexChart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
                    this.player.goTo(xIndex)
                }
            });
        },

        //计算方差
        fc(arr) {
            var sum = 0;
            var s = 0;
            for (var i = 0; i < arr.length; i++) {
                sum += arr[i]
            }
            var ave = sum / arr.length;
            for (var j = 0; j < arr.length; j++) {
                s += Math.pow((ave - arr[j]), 2);
            }
            return Math.sqrt((s / arr.length), 2);
        },
        // 棋子坐标转换
        stoneToPos(val) {
            let pos = {
                X: '',
                Y: ''
            }
            let move = val.toLowerCase()
            if (move == 'pass') {
                pos.X = -1
                pos.Y = -1
            } else {
                if (move.charCodeAt(0) > 105) {
                    pos.X = move.charCodeAt(0) - 98
                } else {
                    pos.X = move.charCodeAt(0) - 97
                }
                pos.Y = parseInt(this.size) - parseInt(move.substr(1, move.length))
            }
            return pos
        },
        // 棋子坐标转换
        stoneToPos1(val) {
            let pos = {
                X: '',
                Y: ''
            }
            let move = val.toLowerCase()
            if (move == 'pass') {
                pos.X = -1
                pos.Y = -1
            } else {
                pos.X = move.charCodeAt(0) - 97
                pos.Y = move.charCodeAt(1) - 97
            }
            return pos
        },
        posToStone(x, y) {
            let xx = "", yy = 0;
            if (x <= 7) {
                xx = String.fromCharCode(x + 97)
            } else {
                xx = String.fromCharCode(x + 98)
            }
            yy = this.size - y
            let stone = xx + yy
            return stone.toUpperCase()
        },
        posToStone1(x, y) {
            let xx = "", yy = "";
            xx = String.fromCharCode(x + 97)
            yy = String.fromCharCode(y + 97)
            let stone = xx + yy
            return stone.toLowerCase()
        },
        //获取cookie
        getCookie(name) {
            let arr;
            let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return null;
            ;
        },
        // 配置分享
        shareWX(obj) {
            if (obj) {
                var title = obj.title == undefined || obj.title == null ? '弈客围棋' : obj.title;
                var circleTitle = obj.circleTitle == undefined || obj.circleTitle == null ? '弈客围棋' : obj.circleTitle;
                var link = obj.link == undefined || obj.link == null ? window.location.href : obj.link;
                var desc = obj.desc == undefined || obj.desc == null ? '弈客围棋' : obj.desc;
                var imgUrl = obj.imgUrl == undefined || obj.imgUrl == null ? 'src/img/share.png' : obj.imgUrl;
                var configList = [];
                if (obj.hideMenu) {
                    configList = [
                        // 所有要调用的 API 都要加到这个列表中
                        'onMenuShareTimeline', //分享到朋友圈
                        'onMenuShareAppMessage', //分享给朋友
                        'onMenuShareQQ', //分享到QQ
                        // 'onMenuShareQZone',//分享到QQ空间
                        'onMenuShareWeibo', //分享到腾讯微博
                        'hideOptionMenu',
                        'hideMenuItems'
                    ];
                } else {
                    configList = [
                        // 所有要调用的 API 都要加到这个列表中
                        'onMenuShareTimeline', //分享到朋友圈
                        'onMenuShareAppMessage', //分享给朋友
                        'onMenuShareQQ', //分享到QQ
                        // 'onMenuShareQZone',//分享到QQ空间
                        'onMenuShareWeibo', //分享到腾讯微博
                    ];
                }
            } else {
                alert('请传分享参数');
            }


            var url = window.location.href.split('#')[0]
            url = url.split('?')[0]
            var data = {
                url: url
            }
            ShareWeChat(data).then(res => {
                var wxdata = JSON.parse(res.result);
                wxdata.jsApiList = configList
                wx.config(wxdata)
                wx.ready(function () {
                    //分享到朋友圈
                    wx.onMenuShareTimeline({
                        title: circleTitle, // 分享标题
                        link: link, // 分享链接
                        desc: desc, // 分享描述
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                        }
                    });
                    //分享到朋友
                    wx.onMenuShareAppMessage({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        type: '', // 分享类型,music、video或link，不填默认为link
                        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                        success: function () {
                        },
                        cancel: function () {
                        }
                    });
                    //分享到QQ
                    wx.onMenuShareQQ({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                        }
                    });

                    //分享到QQ空间
                    wx.onMenuShareQZone({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                        }
                    });

                    //分享到腾讯微博
                    wx.onMenuShareWeibo({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                        }
                    });
                    //QQ分享
                    setShareInfo({
                        title: title, // 分享标题
                        summary: desc, // 分享描述
                        pic: imgUrl,
                        url: link, // 分享链接
                        WXconfig: {
                            swapTitleInWX: true,
                            appId: wxdata.appId,
                            timestamp: wxdata.timestamp,
                            nonceStr: wxdata.nonceStr,
                            signature: wxdata.signature
                        }
                    });
                })
            })
        },
        getTimeStdevC(MoveTimes){
            if (MoveTimes < 2) {
                return this.stdevColor[0];
            } else if (MoveTimes >= 2 & MoveTimes < 4) {
                return this.stdevColor[1];
            } else if (MoveTimes >= 4 & MoveTimes < 9) {
                return this.stdevColor[2];
            } else if (MoveTimes >= 9 & MoveTimes < 16) {
                return this.stdevColor[3];
            } else if (MoveTimes >= 16 & MoveTimes < 31) {
                return this.stdevColor[4];
            } else if (MoveTimes >= 31 & MoveTimes < 61) {
                return this.stdevColor[5];
            } else {
                return this.stdevColor[6];
            }
        },
        getStdevC(score) {
            if (score < 5) {
                return this.stdevColor[0];
            } else if (score >= 5 & score < 12) {
                return this.stdevColor[1];
            } else if (score >= 12 & score < 16) {
                return this.stdevColor[2];
            } else if (score >= 16 & score < 20) {
                return this.stdevColor[3];
            } else if (score >= 20 & score < 25) {
                return this.stdevColor[4];
            } else if (score >= 25 & score < 30) {
                return this.stdevColor[5];
            } else {
                return this.stdevColor[6];
            }
        },
        gopdf() {
            let routeData = this.$router.resolve({
                name: 'report'
            });
            window.open(routeData.href, '_blank');
        },
        gopdf2() {
            if (this.platform == "mobile"||this.platform == "ifk_mobile") {
                this.createPdf()
                // this.$router.push({
                //     name: 'pdf'
                // })
            } else {
                let routeData = this.$router.resolve({
                    name: 'pdf'
                });
                window.open(routeData.href);
            }
        },

        createPdf() {
            let req = {
                token: this.token,
                teacher: this.teacher,
                institution: this.institution
            };
            this.createPDFFlag = true

            getPdf(req).then(result => {
                if (result.code == 0) {
                    let res = result.data
                    setTimeout(() => {
                        this.createPDFFlag = false
                        let url = "static/generic/viewer.html?file=" + res.url + "&title_name=" + this.gName
                        // window.open(config.url + url,"_top");
                        window.location.href = config.url + url
                    }, 1000);
                } else {
                    this.createPDFFlag = false
                    if (result.msg) {
                        alert(result.msg)
                    }
                }

            }).catch(err => {
                this.createPDFFlag = false
                if (err.msg) {
                    alert(err.msg)
                }
            })
        },

        //下载
        onConfirm() {
            window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.indeed.golinks&g_f=991653'
        },
    },
};